import { helper } from '@ember/component/helper';
import classnames from 'classnames';

export default helper(function classNames(positional, named) {
  return classnames(...positional, { ...named });
});
